import { Component, OnInit } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { MatNativeDateModule } from "@angular/material/core";
import { MatDatepickerModule } from "@angular/material/datepicker";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatInputModule } from "@angular/material/input";

declare var ChartsEmbedSDK: any;

@Component({
    selector: 'app-dashboard',
    standalone: true,
    templateUrl: './dashboard.component.html',
    styleUrls: ['./dashboard.component.scss'],
    imports: [
        MatDatepickerModule,
        FormsModule,
        MatFormFieldModule,
        MatInputModule,
        MatNativeDateModule,
    ]
})
export class DashboardComponent implements OnInit {
    private dashboard: any;
    startDate?: Date;
    endDate?: Date;


    ngOnInit(): void {
        const sdk = new ChartsEmbedSDK({
            baseUrl: 'https://charts.mongodb.com/charts-cortijo-prod-vehoxep',
        });

        this.dashboard = sdk.createDashboard({
            dashboardId: '0557ccf0-b10d-43d0-884c-1404a2faa8f3',
        });

        this.dashboard.render(document.getElementById('dashboard')!);
    }

    applyDateFilter(): void {
        if (!this.startDate || !this.endDate) return;

        const filtro = {
            createdAt: {
                $gte: this.startDate,
                $lte: this.endDate
            }
        };

        this.dashboard.setFilter(filtro);

    }
}
